import { create } from 'zustand';
import { createJSONStorage, devtools, persist } from 'zustand/middleware';
import {
    Customer,
    EnvVars,
    GlobalState,
    PortalFile,
    ProductLeadTimes,
    SalesOrder,
} from '../interfaces/Interfaces';

export const useGlobalStore = create<GlobalState>()(
    devtools(
        persist(
            (set) => ({
                env: undefined,
                setEnv: (envs: EnvVars) => {
                    return set(() => ({
                        env: envs,
                    }));
                },
                authenticated: false,
                setAuthenticated: (authed: boolean, username: string) => {
                    setTimeout(() => {
                        useGlobalStore.persist.clearStorage();
                    }, 18000000);
                    return set(() => ({
                        authenticated: authed,
                        username: username,
                    }));
                },
                authToken: '',
                setAuthToken: (token: string) =>
                    set(() => ({ authToken: token })),
                authUsername: '',
                setAuthUsername: (userName: string) =>
                    set(() => ({ authUsername: userName })),
                customerId: '',
                setCustomerId: (id: string) => set(() => ({ customerId: id })),
                customer: null,
                setCustomer: (customer: Customer) =>
                    set(() => ({ customer: customer })),
                customerRoles: null,
                setCustomerRoles: (roles: string) =>
                    set(() => ({ customerRoles: roles })),
                isAdmin: false,
                setIsAdmin: (isAdmin: boolean) =>
                    set(() => ({ isAdmin: isAdmin })),
                salesOrders: [],
                setSalesOrders: (saleOrders: Array<SalesOrder>) =>
                    set(() => ({ salesOrders: saleOrders })),
                tasks: [],
                setTasks: (taskArr: Array<unknown>) =>
                    set(() => ({ tasks: taskArr })),
                marketingFiles: [],
                quoteFiles: [],
                technicalFiles: [],
                setPortalFiles: (allFiles: Array<PortalFile>) => {
                    const marketing = allFiles.filter(
                        (file: PortalFile) => file.category === 'MARKETING',
                    );
                    const quote = allFiles.filter(
                        (file: PortalFile) => file.category === 'QUOTATION',
                    );
                    const technical = allFiles.filter(
                        (file: PortalFile) => file.category === 'TECHNICAL',
                    );

                    return set(() => ({
                        marketingFiles: marketing,
                        quoteFiles: quote,
                        technicalFiles: technical,
                    }));
                },
                productLeadTimes: [],
                setProductLeadTimes: (allFiles: Array<ProductLeadTimes>) => {
                    return set(() => ({
                        productLeadTimes: allFiles,
                    }));
                },
                clearState: () =>
                    set(() => ({
                        authenticated: false,
                        authToken: '',
                        authUsername: '',
                        customerId: '',
                        customer: null,
                        customerRoles: null,
                        isAdmin: false,
                        salesOrders: [],
                        tasks: [],
                        marketingFiles: [],
                        quoteFiles: [],
                        technicalFiles: [],
                    })),
            }),
            {
                name: 'reseller-global',
                storage: createJSONStorage(() => sessionStorage),
            },
        ),
    ),
);
